import React from 'react';
import { getStatusColors } from '@/lib/fmUtils';

/**
 * StatusBadge - colored indicator for RED/YELLOW/GREEN gym status.
 * Sizes: sm = just dot, md = dot + text, lg = full badge with background
 */
export default function StatusBadge({ status, size = 'md', className = '' }) {
  const colors = getStatusColors(status);

  if (size === 'sm') {
    return (
      <span className={`inline-block w-2.5 h-2.5 rounded-full ${colors.indicator} ${className}`} />
    );
  }

  if (size === 'md') {
    return (
      <span className={`inline-flex items-center gap-1.5 ${className}`}>
        <span className={`w-2.5 h-2.5 rounded-full ${colors.indicator}`} />
        <span className={`text-sm font-medium ${colors.text}`}>{status}</span>
      </span>
    );
  }

  // lg: full badge with background
  return (
    <span
      className={`inline-flex items-center gap-2 px-3 py-1 rounded-full ${colors.bg} ${colors.border} border ${className}`}
    >
      <span className={`w-3 h-3 rounded-full ${colors.indicator}`} />
      <span className={`text-sm font-semibold ${colors.text}`}>{status}</span>
    </span>
  );
}
